<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M6,0C6,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1,0,6,0,6C0,6.55,0.45,7,1,7C1,7,6,7,6,7C6.55,7,7,6.55,7,6C7,6,7,1,7,1C7,0.45,6.55,0,6,0C6,0,6,0,6,0ZM11,14C11,13.45,10.55,13,10,13C9.45,13,9,13.45,9,14C9,14,9,15,9,15C9,15.55,9.45,16,10,16C10,16,11,16,11,16C11.55,16,12,15.55,12,15C12,14.45,11.55,14,11,14C11,14,11,14,11,14ZM6,9C6,9,1,9,1,9C0.45,9,0,9.45,0,10C0,10,0,15,0,15C0,15.55,0.45,16,1,16C1,16,6,16,6,16C6.55,16,7,15.55,7,15C7,15,7,10,7,10C7,9.45,6.55,9,6,9C6,9,6,9,6,9ZM15,13C14.45,13,14,13.45,14,14C13.45,14,13,14.45,13,15C13,15.55,13.45,16,14,16C14,16,15,16,15,16C15.55,16,16,15.55,16,15C16,15,16,14,16,14C16,13.45,15.55,13,15,13C15,13,15,13,15,13ZM11,9C11,9,10,9,10,9C9.45,9,9,9.45,9,10C9,10,9,11,9,11C9,11.55,9.45,12,10,12C10.55,12,11,11.55,11,11C11.55,11,12,10.55,12,10C12,9.45,11.55,9,11,9C11,9,11,9,11,9ZM15,0C15,0,10,0,10,0C9.45,0,9,0.45,9,1C9,1,9,6,9,6C9,6.55,9.45,7,10,7C10,7,15,7,15,7C15.55,7,16,6.55,16,6C16,6,16,1,16,1C16,0.45,15.55,0,15,0C15,0,15,0,15,0ZM15,9C15,9,14,9,14,9C13.45,9,13,9.45,13,10C13,10.55,13.45,11,14,11C14,11.55,14.45,12,15,12C15.55,12,16,11.55,16,11C16,11,16,10,16,10C16,9.45,15.55,9,15,9C15,9,15,9,15,9Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'NewGridItem',
} as DefineComponent
</script>
